import { render, staticRenderFns } from "./LinkThreeColorScale.vue?vue&type=template&id=fdbb0046&scoped=true"
import script from "./LinkThreeColorScale.vue?vue&type=script&lang=js"
export * from "./LinkThreeColorScale.vue?vue&type=script&lang=js"
import style0 from "./LinkThreeColorScale.vue?vue&type=style&index=0&id=fdbb0046&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbb0046",
  null
  
)

export default component.exports